/*eslint-disable*/

// detect the runtime path for bundled assets
//
// currently, blank has a `window.app` js variable exposed, and if detected,
// will use cms loading. if not present, fallback to default dev server path.

__webpack_public_path__ = (global.app ? global.app.assetPath : null) || '/js/bundle/';



// WEBPACK FOOTER //
// ./src/frontend/configure-webpack-path.js